/* eslint-disable @typescript-eslint/no-unused-vars */
import { css } from "@emotion/react";
import React, { ErrorInfo } from "react";
// import { trackError } from "../tracking/tracking";

interface IProps {
  errorType?: string;
}

interface IState {
  hasError: boolean;
}

// Source: https://reactjs.org/docs/error-boundaries.html
class ErrorBoundary extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // You can also log the error to an error reporting service
    // trackError(this.props.errorType, {
    //   category: "ErrorBoundry",
    //   context: this.props.context,
    //   error: error.name,
    //   message: error.message,
    //   otherData: this.props.otherData,
    // });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div css={styles.container}>
          <h1>This is embarrassing...&nbsp;&#128563;</h1>
          <h2>Something went wrong.</h2>
          <h3>Please, try again and contact us if the problem persists.</h3>
        </div>
      );
    }

    return this.props.children;
  }
}

// ErrorBoundary.defaultProps = {
//   render: <h1>Something went wrong.</h1>,
//   errorType: "UnknownBoundryError",
//   otherData: {},
//   context: "notDefined",
// };

export default ErrorBoundary;

const styles = {
  container: css`
    margin: auto;
    text-align: center;
  `,
};
